import { Injectable } from '@angular/core';
import { SideMenuModel } from './side-menu.model';
import { MenuSectionModel } from './menu-section.model';

@Injectable()
export class SideMenuService {
    private model = new SideMenuModel();

    public addSection(section: MenuSectionModel): void {
        this.model.sections.push(section);
    }

    public getModel(): SideMenuModel {
        return this.model;
    }

    public displayEntry(sectionTitle: string, entryTitle: string): void {
        const section = this.model.sections.find((s) => s.title === sectionTitle);
        if (section) {
            const entry = section.entries.find((e) => e.title === entryTitle);
            if (entry) {
                entry.visible = true;
            }
        }
    }

    public hideEntry(sectionTitle: string, entryTitle: string): void {
        const section = this.model.sections.find((s) => s.title === sectionTitle);
        if (section) {
            const entry = section.entries.find((e) => e.title === entryTitle);
            if (entry) {
                entry.visible = false;
            }
        }
    }

    public disableEntry(sectionTitle: string, entryTitle: string): void {
        const section = this.model.sections.find((s) => s.title === sectionTitle);
        if (section) {
            const entry = section.entries.find((e) => e.title === entryTitle);
            if (entry) {
                entry.disabled = true;
            }
        }
    }

    public enableEntry(sectionTitle: string, entryTitle: string): void {
        const section = this.model.sections.find((s) => s.title === sectionTitle);
        if (section) {
            const entry = section.entries.find((e) => e.title === entryTitle);
            if (entry) {
                entry.disabled = false;
            }
        }
    }
}
